export const formatDefault = (date: string | undefined) => {
    if (!date) return new Date();
    const split = date.split('T');
    const first = split[0].split('/');
    return new Date(Date.UTC(parseInt(first[2]), parseInt(first[1]) - 1, parseInt(first[0])));
}